<template>
  <v-container fluid class="background-white fill-height">
    <v-row class="no-gutters flex-wrap flex-column fill-height">
      <v-col cols="auto">
        <campaign-image :imageUrl="imageUrl" />
      </v-col>
      <v-col cols="auto" class="grow gray mb-8">
        <qrcode-body :npo="npo" :isLeading="isLeading" :title="title" :skipConfig="skipConfig"/>
      </v-col>
    </v-row>
    <v-fab-transition
    >
      <v-btn
        color="white"
        class="mt-8"
        small
        absolute
        top
        left
        fab
        @click="goBack"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-container>
</template>

<script>
import campaignImage from '@/components/qrcode-vote-components/BaseHeaderImage'
import qrcodeBody from '@/views/qrcodevote/giftcard-app/QrcodeBody'

export default {
  props: {
    npo: {
      type: Object
    },
    leadId: {
      type: String,
      default: ''
    },
    token: {
      type: String
    },
    title: {
      type: String
    },
    skipConfig: {
      type: Boolean
    }
  },
  components: {
    'campaign-image': campaignImage,
    'qrcode-body': qrcodeBody
  },
  data () {
    return {
      imageUrl: '@/assets/the_good_company_logo.jpg',
      campaignId: null,
      dataLoading: true,
      dataLoaded: false,
      isLeading: false
    }
  },

  created () {
    if (JSON.parse(sessionStorage.getItem('campaign'))) {
      const campaign = JSON.parse(sessionStorage.getItem('campaign'))
      this.campaignId = campaign.campaign
      this.imageUrl = campaign.logo
    } else {
      this.campaignId = sessionStorage.getItem('campaign_id')
    }

    if (sessionStorage.getItem('isLeading') === 'true') {
      this.isLeading = true
    }
  },

  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
</style>
